import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { CommonService } from '../shared/common/common.service';

@Injectable({
  providedIn: 'root',
})
export class BookingLogService {
  private userDetails: any;

  constructor(
    private service: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private commonService: CommonService,
  ) {
    this.userDetails = this.commonService.userDetails;
  }

  logBookingAction(
    oldStatus: string,
    newStatus: string,
    params: any,
    feature_servide: string,
  ): Observable<any> {
    const payload = {
      booking_id:
        feature_servide == 'consultation'
          ? params?.tc_booking_id
          : params?.ambulance_booking_id,
      feature_service_id: feature_servide,
      patient_user_id: params?.user_id || params?.user?.user_id,
      old_status: oldStatus,
      new_status: newStatus,
      created_by_user_id:
        this.userDetails?.user_id ??
        JSON.parse(localStorage.getItem('user') || '{}')?.user_id ??
        null,
    };

    this.spinner.show();

    return this.service.createBookingLogs(payload).pipe(
      finalize(() => this.spinner.hide()),
      catchError((error) => {
        this.toastr.error(
          error?.error?.message || error?.error?.error || 'An error occurred',
        );
        return throwError(() => error);
      }),
    );
  }

  getLoginSource(): 'WEB' | 'WAP' {
    const agent = navigator.userAgent.toLowerCase();

    const isTablet =
      /ipad|tablet|playbook|silk/i.test(agent) ||
      (/android/i.test(agent) && !/mobile/i.test(agent));

    const isMobile =
      !isTablet &&
      /android|iphone|ipod|mobile|series40|series30plus|blackberry|opera mini|nokia|symbian|j2me|ucweb|kaios/i.test(
        agent,
      );

    return isMobile ? 'WAP' : 'WEB';
  }
}
